import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Item = ({ isHoverStyleNeeded, disabled, selected, hidden, style, onClick, children }) => {
  const handleClick = event => (disabled ? null : onClick(event));
  const isPointer = !!handleClick;

  if (hidden) {
    return null;
  }

  return (
    <Container
      isHoverStyleNeeded={isHoverStyleNeeded}
      isPointer={isPointer}
      disabled={disabled}
      selected={selected}
      style={style}
      onClick={onClick}
    >
      {children}
    </Container>
  );
};

Item.propTypes = {
  isHoverStyleNeeded: PropTypes.bool,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  hidden: PropTypes.bool,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

Item.defaultProps = {
  isHoverStyleNeeded: true,
  disabled: false,
  selected: false,
  hidden: false,
  style: {},
  onClick: () => {},
};

const Container = styled.div`
  display: flex;
  flex: 1;
  padding: 8px;

  cursor: ${({ isPointer }) => isPointer && 'pointer'};
  opacity: ${({ disabled }) => disabled && 0.5};

  background-color: ${({ theme, selected }) => selected && theme.colors.ui_2};

  &:hover {
    background-color: ${({ isHoverStyleNeeded, theme }) => isHoverStyleNeeded && theme.colors.ui_2};
  }
`;

export default Item;
